import { tryURL } from '@aigc/toolkit';
import type { Nullish } from '@aigc/types';
import type { UploadFile } from 'antd';
import mime from 'mime';
import { v7 as uuid } from 'uuid';
import type { FileInputDto, UploadFileOutputDto } from './model';

export function toFileListUrls(
  fileList: Nullish<UploadFile<UploadFileOutputDto>[]>,
): string[] {
  return (
    fileList
      ?.filter((item) => item.status === 'done' && item.response)
      .map((item) => item.response!.file_url) ?? []
  );
}

export function toFileInputDtoList(
  fileList: Nullish<UploadFile<UploadFileOutputDto>[]>,
): FileInputDto[] {
  return (
    fileList
      ?.filter((item) => item.status === 'done' && item.response)
      .map((item) => ({
        name: item.name,
        type: item.type!,
        url: item.response!.file_url,
      })) ?? []
  );
}

export function toFileListFormValues(
  url: string[],
  defaultMime?: string,
): UploadFile<UploadFileOutputDto>[];
export function toFileListFormValues(
  url: FileInputDto[],
): UploadFile<UploadFileOutputDto>[];
export function toFileListFormValues(
  data: Array<string | FileInputDto>,
  defaultMime?: string,
): UploadFile<UploadFileOutputDto>[] {
  return data.map<UploadFile<UploadFileOutputDto>>((item) => {
    let name = '';
    let type: string | undefined;
    let url = '';

    if (typeof item === 'string') {
      const path = tryURL(item)?.pathname ?? item.split(/[?#]/)[0] ?? '';
      name = path.split('/').at(-1) ?? '';
      try {
        name = window.decodeURIComponent(name);
      } catch {
        // 无效的 URL 编码保留原文件名。
      }
      url = item;
    } else {
      name = item.name;
      type = item.type;
      url = item.url;
    }

    const resolvedType = type || mime.getType(name) || defaultMime;
    return {
      uid: uuid(),
      name,
      status: 'done',
      url,
      type: resolvedType,
      response: {
        file_url: url,
        filename: name,
        mime: resolvedType!,
      },
    };
  });
}

export function getImageUrls(files: Nullish<FileInputDto[]>) {
  return files
    ?.filter((item) => item.type.startsWith('image/'))
    .map((item) => item.url);
}

export function getVideoUrls(files: Nullish<FileInputDto[]>) {
  return files
    ?.filter((item) => item.type.startsWith('video/'))
    .map((item) => item.url);
}

export function getAudioUrls(files: Nullish<FileInputDto[]>) {
  return files
    ?.filter((item) => item.type.startsWith('audio/'))
    .map((item) => item.url);
}
